import { render, staticRenderFns } from "./orderWorkspace.vue?vue&type=template&id=b9aff7ac&"
import script from "./orderWorkspace.vue?vue&type=script&lang=js&"
export * from "./orderWorkspace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b9aff7ac')) {
      api.createRecord('b9aff7ac', component.options)
    } else {
      api.reload('b9aff7ac', component.options)
    }
    module.hot.accept("./orderWorkspace.vue?vue&type=template&id=b9aff7ac&", function () {
      api.rerender('b9aff7ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/FBA/Order/orderWorkspace.vue"
export default component.exports